module.exports = __webpack_public_path__ + "images/emoji/jp.8867a62d1aa976ae6c23.png";